import { useMutation } from '@tanstack/react-query';
import { createDonation } from '@/lib/api/donations';
import type { CreateDonationRequest } from '@/types/donation';

/**
 * Hook to create a donation
 * Returns mutation function and state (loading, error, data)
 */
export function useDonation() {
  return useMutation({
    mutationFn: (data: CreateDonationRequest) => createDonation(data),
    onSuccess: () => {
      // Payment initiation is now handled client-side in the component
    },
    onError: (error) => {
      console.error('Donation creation failed:', error);
    },
  });
}
